module.exports = __webpack_public_path__ + "img/print-magnifying-glass.827e4224.svg";